import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useStore from './pane-state-hook';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.primaryColor};
  }
`;
const Indicator = styled.span`
  color: ${props => props.theme.primaryColor};
  font-weight: ${props => props.theme.fontWeightDccc};
  font-size: 24px;
`;

export default function Header({ children, eventKey }) {
  const expanded = useStore(React.useCallback(state => state.panesExpanded[eventKey], [eventKey]));
  const set = useStore(state => state.set);

  const onClick = e => {
    e && e.preventDefault();
    set(state => {
      state.panesExpanded[eventKey] = !state.panesExpanded[eventKey];
    });
  };

  return (
    <Container onClick={onClick}>
      <h3>{children}</h3>
      <Indicator>{expanded ? '\u2212' : '+'}</Indicator>
    </Container>
  );
}

Header.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string.isRequired,
};
